import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';

class Profile extends Component {
  constructor(props){
    super(props);
    //console.log('props', props);
    this.state = {
      isAuthenticated: null,
      userProfile: {}
    }

    this.checkAuth = this.checkAuth.bind(this);
    this.getProfile = this.getProfile.bind(this);
  }

  componentDidMount(){
    this.checkAuth();
    //this.getProfile();
  }

  checkAuth(){
    let apiUrl = `${window.location.protocol}//${window.location.host}/auth/authenticated`;
    fetch(apiUrl)
    .then(res => res.json())
    .then(({isAuthenticated, userProfile}) => {
      if(!isAuthenticated) {
        //redirect to login page
        this.props.history.push('/login');
        return;
      }
      this.setState({
        isAuthenticated,
        userProfile
      });
    });
  }

  getProfile(){
    //console.log('getting profile');
  }

  render(){
     if(this.state.isAuthenticated === true) {
      return(
        <div className="profile-content">
          <h1>User Profile</h1>
          <div className="form-group">
            <label for="username">Username:</label>
            <input 
              name="username" 
              type="text" 
              className="form-control" 
              value={this.state.userProfile.userName}></input>
          </div>
          <div className="form-group">
            <label for="firstname">First name:</label>
            <input 
              name="firstname"
              type="text" 
              className="form-control" 
              value={this.state.userProfile.firstName}></input>
          </div>
          <div className="form-group">
            <label for="lastname">Last name:</label>
            <input
              name="lastname"
              type="text" 
              className="form-control" 
              value={this.state.userProfile.lastName}></input>
          </div>
          <div className="form-group">
            <label for="email">Email:</label>
            <input 
              name="email" 
              type="text" 
              className="form-control" 
              value={this.state.userProfile.email}></input>
          </div>
          <div className="form-group">
            <label for="image">Image:</label>
            <img 
              className="profile-image" 
              href={this.state.userProfile.imageUrl}></img>
          </div>
        </div>
      );
    } else {
      return (<div></div>);
    }
  }
}

export default withRouter(Profile);